

import request from "@/utils/request";

export function taskList(data) {
  return request({
    url: "/test/taskInfo/getTestTaskPageByCondition",
    method: "post",
    data:data
  });
}

//任務管理-撤銷申請
export function deleteTestTaskAndRels(id) {
  return request({
    url: `/test/taskInfo/deleteTestTaskAndRels?id=${id}`,
    method: "get",
  });
}

//结束任务finishTestTask
export function finishTestTask(id) {
  return request({
    url: `/test/taskInfo/finishTestTask?id=${id}`,
    method: "get",
  });
}

export function approvalTestTask(data) {
  return request({
    url: "/test/taskInfo/approvalTestTask",
    method: "post",
    data:data
  });
}

//测试中任务统计
export function testingCount() {
  return request({
    url: '/test/taskInfo/testingCount',
    method: 'get'
  })
}

//测试累计里程日统计
export function accumulatedMileageDailyCount() {
  return request({
    url: '/test/taskInfo/daily/accumulatedMileageCount',
    method: 'get'
  })
}

//测试累计里程月统计
export function accumulatedMileageMonthlyCount() {
  return request({
    url: '/test/taskInfo/monthly/accumulatedMileageCount',
    method: 'get'
  })
}
